import { useTheme } from "../../../contexts/ThemeContext";

const LOGO = "https://public.readdy.ai/ai/img_res/c055e417-8161-4888-b526-7bdc05bd652e.png";

export default function Footer() {
  const { isDark } = useTheme();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const bg = isDark ? "bg-[#000] border-white/[0.07]" : "bg-[#F5F5F7] border-black/[0.08]";
  const innerBorder = isDark ? "border-white/[0.06]" : "border-black/[0.07]";
  const brandText = isDark ? "text-white/35" : "text-[#6e6e73]";
  const socialColor = isDark ? "text-white/30 hover:text-white" : "text-black/30 hover:text-black";
  const linkColor = isDark ? "text-white/40 hover:text-white" : "text-black/40 hover:text-black";
  const industryText = isDark ? "text-white/40" : "text-black/40";
  const contactText = isDark ? "text-white/40" : "text-black/40";
  const copyText = isDark ? "text-white/20" : "text-black/20";
  const legalLink = isDark ? "text-white/20 hover:text-white/50" : "text-black/20 hover:text-black/50";

  return (
    <footer className={`border-t px-6 md:px-10 pt-16 pb-10 transition-colors duration-300 ${bg}`}>
      <div className="max-w-[1280px] mx-auto">
        <div className={`grid grid-cols-1 md:grid-cols-5 gap-10 pb-14 border-b ${innerBorder}`}>

          {/* Brand */}
          <div className="md:col-span-2">
            <img src={LOGO} alt="AI Talent Launch" className="object-contain mb-5" style={{ width: "90px", height: "90px" }} />
            <p className={`${brandText} text-[13px] leading-relaxed max-w-xs mb-7`}>
              Deploy smarter talent. Scale without hiring.<br />
              AI-powered workforce infrastructure for service-based businesses.
            </p>
            <div className="flex items-center gap-2.5">
              {[
                { icon: "ri-twitter-x-line" },
                { icon: "ri-linkedin-fill" },
                { icon: "ri-instagram-line" },
                { icon: "ri-facebook-circle-fill" },
              ].map((s, i) => (
                <a key={i} href="#" rel="nofollow noopener" className={`w-8 h-8 flex items-center justify-center transition-colors duration-200 cursor-pointer ${socialColor}`}>
                  <i className={`${s.icon} text-[15px]`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-[#F97316] text-[11px] font-semibold tracking-widest uppercase mb-5">Navigate</h4>
            <ul className="flex flex-col gap-3.5">
              {[{ label: "How It Works", id: "how-it-works" }, { label: "Benefits", id: "benefits" }, { label: "Industries", id: "industries" }, { label: "Our Process", id: "deployment" }, { label: "Contact", id: "contact" }].map((link) => (
                <li key={link.id}>
                  <button onClick={() => scrollTo(link.id)} className={`${linkColor} text-[13px] transition-colors duration-200 cursor-pointer whitespace-nowrap`}>{link.label}</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-[#22C55E] text-[11px] font-semibold tracking-widest uppercase mb-5">Industries</h4>
            <ul className="flex flex-col gap-3.5">
              {["Home Services", "HVAC & Plumbing", "Gyms & Fitness", "Wellness & Spas", "Chiropractic", "Physical Therapy"].map((item) => (
                <li key={item}><span className={`${industryText} text-[13px]`}>{item}</span></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#38BDF8] text-[11px] font-semibold tracking-widest uppercase mb-5">Contact</h4>
            <ul className="flex flex-col gap-4">
              {[
                { icon: "ri-mail-line", color: "#38BDF8", text: "hello@aitalentlaunch.com" },
                { icon: "ri-phone-line", color: "#22C55E", text: "(800) 123-4567" },
                { icon: "ri-map-pin-line", color: "#F97316", text: "United States" },
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <i className={`${item.icon} text-[14px]`} style={{ color: item.color }}></i>
                  <span className={`${contactText} text-[13px]`}>{item.text}</span>
                </li>
              ))}
            </ul>
            <button onClick={() => scrollTo("contact")} className="mt-6 bg-[#F97316] text-white text-[12px] font-semibold px-5 py-2.5 rounded-full hover:bg-[#FB923C] transition-all cursor-pointer whitespace-nowrap">
              Get Free Assessment
            </button>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className={`${copyText} text-[12px]`}>&copy; {new Date().getFullYear()} AI Talent Launch. All rights reserved.</p>
          <div className="flex items-center gap-6">
            {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((item) => (
              <a key={item} href="#" rel="nofollow" className={`${legalLink} text-[12px] transition-colors cursor-pointer whitespace-nowrap`}>{item}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
